module.exports = __webpack_public_path__ + "media/packs/images/panes/cost-6a19534a04b4ec0c82a51aa02976178a.svg";